import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-255a2aa7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-tab" }
const _hoisted_2 = { class: "card-tab__wrap" }


import { IDisplayContent } from "./Card.vue";
import IconContract from "@/assets/svgs/icon_contract.svg";
import IconContractOrange from "@/assets/svgs/icon_contract_orange.svg";
import IconInvoice from "@/assets/svgs/icon_invoice.svg";
import IconInvoiceOrange from "@/assets/svgs/icon_invoice_orange.svg";

interface IProps {
  mode: IDisplayContent;
  changeMode: (mode: IDisplayContent) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardTab',
  props: {
    mode: {},
    changeMode: { type: Function }
  },
  setup(__props: any) {

const props = __props;



const isSelectedTab = (mode: IDisplayContent) => {
  return mode === props.mode;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["card-tab__item", {
          'card-tab__item--active': _ctx.mode === 'contractInfo',
        }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeMode('contractInfo')))
      }, [
        (isSelectedTab('contractInfo'))
          ? (_openBlock(), _createBlock(_unref(IconContractOrange), {
              key: 0,
              class: "icon-svg"
            }))
          : (_openBlock(), _createBlock(_unref(IconContract), {
              key: 1,
              class: "icon-svg"
            })),
        _createTextVNode(" 契約情報 ")
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["card-tab__item", { 'card-tab__item--active': _ctx.mode === 'invoiceInfo' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMode('invoiceInfo')))
      }, [
        (isSelectedTab('invoiceInfo'))
          ? (_openBlock(), _createBlock(_unref(IconInvoiceOrange), {
              key: 0,
              class: "icon-svg"
            }))
          : (_openBlock(), _createBlock(_unref(IconInvoice), {
              key: 1,
              class: "icon-svg"
            })),
        _createTextVNode(" 請求書記載情報 ")
      ], 2)
    ])
  ]))
}
}

})